import * as lloydsascnallincl from '../clients/lloydsascnallincl';
import * as lloydsascnnonmed from '../clients/lloydsascnnonmed';
import * as lloydsascnoop from '../clients/lloydsascnoop';
import * as lloydscanuckvoyage from '../clients/lloydscanuckvoyage';
import * as lloydscomprehensiveplus from '../clients/lloydscomprehensiveplus';
import * as lloydsdiscovercanada from '../clients/lloydsdiscovercanada';
import * as lloydsessentialplanis from '../clients/lloydsessentialplanis';
import * as lloydsessentialworldwideplanis from '../clients/lloydsessentialworldwideplanis';
import * as lloydsetrstudent from '../clients/lloydsetrstudent';
import * as lloydsexplorecanadais from '../clients/lloydsexplorecanadais';
import * as lloydsis from '../clients/lloydsis';
import * as lloydsmycanadais from '../clients/lloydsmycanadais';
import * as lloydsmycanadaplusis from '../clients/lloydsmycanadaplusis';
import * as lloydsoutboundstudent from '../clients/lloydsoutboundstudent';
import * as lloydsstudycanadais from '../clients/lloydsstudycanadais';
import * as lloydsusis from '../clients/lloydsusis';
import * as msgascnnonmed from '../clients/msgascnnonmed';
import * as msgascnallincl from '../clients/msgascnallincl';
import * as msgemergencymedical from '../clients/msgemergencymedical';
import * as msgis from '../clients/msgis';
import * as msgvisitorstocanada from '../clients/msgvisitorstocanada';
import * as tpageneric from '../clients/tpageneric';
import * as blanket from '../clients/blanket';
import * as ubcimedblanket from '../clients/ubcimedblanket';
import * as rimissis from '../clients/rimissis';
import * as rimicanuckvoyage from '../clients/rimicanuckvoyage';
import * as rimivisitorstocanada from '../clients/rimivisitorstocanada';
import * as visitcanadavisitors from '../clients/visitcanadavisitors';
import * as studentaccidentplan from '../clients/studentaccidentplan';
import * as visitcanadais from '../clients/visitcanadais';
import * as insurecanadais from '../clients/insurecanadais';
import * as insurecanadavisitor from '../clients/insurecanadavisitor';
import * as rimicanuckvoyagenonmed from '../clients/rimicanuckvoyagenonmed';



export function getClientExpandedGroup(clientName) {
  return getClientExpandedGroups()[clientName];
}

export function getClientConfig(clientName) {
  return getClientModules()[clientName];
}

function getClientModules() {
  return {
    lloydsascnallincl: lloydsascnallincl.fields(),
    lloydsascnnonmed: lloydsascnnonmed.fields(),
    lloydsascnoop: lloydsascnoop.fields(),
    lloydscomprehensiveplus: lloydscomprehensiveplus.fields(),
    lloydsdiscovercanada: lloydsdiscovercanada.fields(),
    lloydsessentialplanis: lloydsessentialplanis.fields(),
    lloydsessentialworldwideplanis: lloydsessentialworldwideplanis.fields(),
    lloydsetrstudent: lloydsetrstudent.fields(),
    lloydsexplorecanadais: lloydsexplorecanadais.fields(),
    lloydsis: lloydsis.fields(),
    lloydsmycanadais: lloydsmycanadais.fields(),
    lloydsmycanadaplusis: lloydsmycanadaplusis.fields(),
    lloydsoutboundstudent: lloydsoutboundstudent.fields(),
    lloydsstudycanadais: lloydsstudycanadais.fields(),
    lloydsusis: lloydsusis.fields(),
    lloydscanuckvoyage: lloydscanuckvoyage.fields(),
    msgascnallincl: msgascnallincl.fields(),
    msgascnnonmed: msgascnnonmed.fields(),
    msgemergencymedical: msgemergencymedical.fields(),
    msgis: msgis.fields(),
    msgvisitorstocanada: msgvisitorstocanada.fields(),
    tpageneric: tpageneric.fields(),
    blanket: blanket.fields(),
    ubcimedblanket: ubcimedblanket.fields(),
    rimissis: rimissis.fields(),
    rimicanuckvoyage: rimicanuckvoyage.fields(),
    rimivisitorstocanada: rimivisitorstocanada.fields(),
    visitcanadavisitors: visitcanadavisitors.fields(),
    studentaccidentplan: studentaccidentplan.fields(),
    visitcanadais: visitcanadais.fields(),
    insurecanadais: insurecanadais.fields(),
    insurecanadavisitor: insurecanadavisitor.fields(),
    rimicanuckvoyagenonmed:rimicanuckvoyagenonmed.fields(),
  }
}

function getClientExpandedGroups() {
  return {
    lloydsascnallincl: lloydsascnallincl.expandedGroups(),
    lloydsascnnonmed: lloydsascnnonmed.expandedGroups(),
    lloydsascnoop: lloydsascnoop.expandedGroups(),
    lloydscomprehensiveplus: lloydscomprehensiveplus.expandedGroups(),
    lloydsdiscovercanada: lloydsdiscovercanada.expandedGroups(),
    lloydsessentialplanis: lloydsessentialplanis.expandedGroups(),
    lloydsessentialworldwideplanis: lloydsessentialworldwideplanis.expandedGroups(),
    lloydsetrstudent: lloydsetrstudent.expandedGroups(),
    lloydsexplorecanadais: lloydsexplorecanadais.expandedGroups(),
    lloydsis: lloydsis.expandedGroups(),
    lloydsmycanadais: lloydsmycanadais.expandedGroups(),
    lloydsmycanadaplusis: lloydsmycanadaplusis.expandedGroups(),
    lloydsoutboundstudent: lloydsoutboundstudent.expandedGroups(),
    lloydsstudycanadais: lloydsstudycanadais.expandedGroups(),
    lloydsusis: lloydsusis.expandedGroups(),
    lloydscanuckvoyage: lloydscanuckvoyage.expandedGroups(),
    msgascnallincl: msgascnallincl.expandedGroups(),
    msgascnnonmed: msgascnnonmed.expandedGroups(),
    msgemergencymedical: msgemergencymedical.expandedGroups(),
    msgis: msgis.expandedGroups(),
    msgvisitorstocanada: msgvisitorstocanada.expandedGroups(),
    tpageneric: tpageneric.expandedGroups(),
    blanket: blanket.expandedGroups(),
    ubcimedblanket: ubcimedblanket.expandedGroups(),
    rimissis: rimissis.expandedGroups(),
    rimicanuckvoyage: rimicanuckvoyage.expandedGroups(),
    rimivisitorstocanada: rimivisitorstocanada.expandedGroups(),
    visitcanadavisitors: visitcanadavisitors.expandedGroups(),
    studentaccidentplan: studentaccidentplan.expandedGroups(),
    visitcanadais: visitcanadais.expandedGroups(),
    insurecanadais: insurecanadais.expandedGroups(),
    insurecanadavisitor: insurecanadavisitor.expandedGroups(),
    rimicanuckvoyagenonmed: rimicanuckvoyagenonmed.expandedGroups(),
  }
}



// WEBPACK FOOTER //
// ./src/helpers/clients.js